var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BButton,{attrs:{"variant":"link"},on:{"click":function($event){return _setup.emit('click')}}},[_vm._v("I know what I am doing, force "+_vm._s(_vm.action.toLowerCase())+".")])
}
var staticRenderFns = []

export { render, staticRenderFns }